"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledSubmitError = exports.FormValidationSummary = exports.FormErrorSummary = void 0;
var _mui = require("@ori-ui/mui");
var _react = require("react");
var _Localization = require("../Localization");
var _constants = require("../constants");
var _models = require("../models");
var _utils = require("../utils");
var _jsxRuntime = require("react/jsx-runtime");
const FormErrorSummary = exports.FormErrorSummary = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  marginBottom: theme.spacing(6)
}));
const StyledSubmitError = exports.StyledSubmitError = (0, _mui.styled)(_mui.FormHelperText)(() => ({
  fontSize: '14px',
  textAlign: 'center',
  fontStyle: 'italic',
  margin: '0 auto'
}));
const StyledLink = (0, _mui.styled)('a')(({
  theme
}) => ({
  color: theme.palette.error.main,
  textDecoration: 'underline',
  fontWeight: 'bold',
  '&:hover': {
    color: theme.palette.error.main,
    textDecoration: 'underline'
  }
}));
const FormValidationSummary = props => {
  const {
    invalidPropertyErrors,
    customerServiceUrl,
    loginUrl
  } = props;
  const isInvalidPropertyErrors = Boolean(invalidPropertyErrors?.length && invalidPropertyErrors.length > 0);
  (0, _react.useEffect)(() => {
    (0, _utils.scrollTopFunctionHelper)();
  }, [isInvalidPropertyErrors]);
  if (!isInvalidPropertyErrors) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(FormErrorSummary, {
    children: invalidPropertyErrors?.map(notPropertyError => /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledSubmitError, {
      error: true,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
        ...(0, _utils.getErrorLocalizationByCode)(notPropertyError.errorCode),
        values: {
          customerServiceLink: /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledLink, {
            href: customerServiceUrl,
            target: "_blank",
            rel: "noreferrer",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
              defaultMessage: _constants.defaultTranslations.customerServiceLinkLabel,
              id: _models.TranslationKey.customerServiceLinkLabel
            })
          }),
          loginLink: /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledLink, {
            href: loginUrl,
            target: "_blank",
            rel: "noreferrer",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
              defaultMessage: _constants.defaultTranslations.loginLinkLabel,
              id: _models.TranslationKey.loginLinkLabel
            })
          })
        }
      })
    }, notPropertyError.errorCode))
  });
};
exports.FormValidationSummary = FormValidationSummary;
//# sourceMappingURL=FormValidationSummary.js.map